var map = {
	"./AssetsAllocation.vue": "FxC6",
	"./Footer.vue": "TVmP",
	"./Header.vue": "teIl",
	"./Hello.vue": "qSdX",
	"./LanguageChanger.vue": "lU6e",
	"./Legends.vue": "5eh/",
	"./LoadingSpinner.vue": "92is",
	"./Select.vue": "wi0O",
	"./Table.vue": "ABj6",
	"./TableDataCell.vue": "kK1u",
	"./TableHeading.vue": "pbCb",
	"./TableRow.vue": "XlGF",
	"./VerticalBar.vue": "hrg7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZBoC";


//////////////////
// WEBPACK FOOTER
// ./src/components \.vue$
// module id = ZBoC
// module chunks = 1